export const TERMINAL_BOOKING_URL = '../json/terminalPageController/evoTerminalBooking';
export const TERMINAL_PERSURL_URL = '../json/terminalPageController/evoTerminalPersurl';
export const TERMINAL_DEFAULT_PERS_NR = -1;